'use client';

import { useEffect } from 'react';
import { hasCustomerSession } from './authApi';

export default function Root() {
  useEffect(() => {
    hasCustomerSession().then((ok) => {
      window.location.replace(ok ? '/home.html' : '/login/');
    });
  }, []);
  return null;
}
